

import clientAPI from "@/api/ClientAPIMixin.js";
import KeyDiverMixin from "@/helpers/Mixins/KeyDiverMixin";
import Vue from "vue";



export const JobParentjob = {
  namespaced: true,


  state: {
    NewJobDetails: {},
    OldJobDetails: {},
    Order: null,
    CreateJobLoading: false,
  },



  mutations: {
    SET_JOBDETAIL(state, newjobdetail) {
      var keyObjectPair = KeyDiverMixin.methods.getValueFromKeychainNotLastKey(state.OldJobDetails, newjobdetail.key)
      Vue.set(keyObjectPair.object, keyObjectPair.key, newjobdetail.value);
    },
    SET_NEW_JOBDETAIL(state, newjobdetail) {
      var keyObjectPair = KeyDiverMixin.methods.getValueFromKeychainNotLastKey(state.NewJobDetails, newjobdetail.key)
      Vue.set(keyObjectPair.object, keyObjectPair.key, newjobdetail.value);
    },
    SET_JOBDETAILS(state, newjobdetails) {
      state.OldJobDetails = newjobdetails;
      state.NewJobDetails = newjobdetails;
    },
    SET_NEW_JOBDETAILS(state, newjobdetails) {
      state.NewJobDetails = newjobdetails;
    },

    SET_JOB_ORDER(state, newjoborder) {
      state.Order = newjoborder;
    },
    SET_JOB_ORDERFIELD(state, neworderfield) {
      var keyObjectPair = KeyDiverMixin.methods.getValueFromKeychainNotLastKey(state.Order, neworderfield.key)
      Vue.set(keyObjectPair.object, keyObjectPair.key, neworderfield.value);

    },
  },



  actions: {
    setJobDetail({ commit }, newjobdetail) {
      commit("SET_JOBDETAIL", newjobdetail);
    },
    setNewJobDetail({ commit }, newjobdetail) {
      commit("SET_NEW_JOBDETAIL", newjobdetail);
    },
    setJobDetails({ commit }, newjobdetails) {
      commit("SET_JOBDETAILS", newjobdetails);
    },
    setNewJobDetails({ commit }, newjobdetails) {
      commit("SET_NEW_JOBDETAILS", newjobdetails);
    },

    setJobOrderField({ commit }, neworderfield) {
      commit("SET_JOB_ORDERFIELD", neworderfield);
    },
    setJobOrder({ commit }, neworder) {
      commit("SET_JOB_ORDER", neworder);
    },

    /**============================================
    *?ANCHOR               GET JOB DETAILS
    *===========================================**/
    getJobDetails({ dispatch }, id) {
      clientAPI.methods.getJobById(id)
        .then((response) => {
          dispatch('setJobDetails', response);
        })

    },

    /**============================================
    *?ANCHOR               SAVE JOB DETAILS
    *===========================================**/
    async saveJobDetails({ state }) {
      var details = state.NewJobDetails
      details.NoInvoice = (details.NoInvoice === true)
      return await clientAPI.methods.saveJobDetails(details);
    },

    /**============================================
    *?ANCHOR               COPY JOB
    *===========================================**/
    copyjob({ dispatch, commit, state, rootGetters }) {

      var oldjob = Object.assign({}, state.OldJobDetails);
      oldjob.Id = undefined;
      oldjob.DisplayName = null;
      oldjob.JobStatusId = 10;
      oldjob.JobSubStatusId = null;

      commit("SET_JOBDETAILS", oldjob);

      var inSubjobs = rootGetters['JobHub/JobSubjobs/Subjobs'];

      var subjobs = [];
      inSubjobs.forEach((subjob) => {
        var newsubjob = {
          Id: crypto.randomUUID(), // temporary id
          New: true,
          MachineId: subjob.Machine.Id,
          Machine: subjob.Machine,
          InvoiceComment: subjob.InvoiceComment,
          CustomerComment: subjob.CustomerComment,
          SupplierFailureCodeId: subjob.SupplierFailureCodeId,
          WarrentyTypeId: subjob.WarrentyTypeId,
          RepairPlaceId: subjob.RepairPlaceId,
          NewCustomerComment: subjob.CustomerComment,
          NewSupplierFailureCodeId: subjob.SupplierFailureCodeId
        }
        subjobs.push(newsubjob);
      });

      dispatch('JobHub/JobSubjobs/clearSubjobs', null, { root: true });
      dispatch('JobHub/JobSubjobs/addSubjobs', subjobs, { root: true });
    },

    /**============================================
    *?ANCHOR               CREATE JOB
    *===========================================**/
    async createJob({ state, rootGetters }) {
      state.CreateJobLoading = true;

      var Customer = rootGetters['JobHub/JobCustomer/Customer'];
      var Contact = rootGetters['JobHub/JobCustomer/CustomerContact'];
      var Address = rootGetters['JobHub/JobCustomer/CustomerDeliveryAdress'];

      var inSubjobs = rootGetters['JobHub/JobSubjobs/Subjobs'];

      var subjobs = [];
      inSubjobs?.forEach((subjob) => {
        subjobs.push({
          MachineId: subjob.Machine.Id,
          //InvoiceComment: subjob.InvoiceComment,
          CustomerComment: subjob.CustomerComment,
          WarrentyTypeId: subjob.WarrentyTypeId,
          RepairPlaceId: subjob.RepairPlaceId,
          JobCategoryId: subjob.JobCategoryId,
          SupplierFailureCodeId: subjob.SupplierFailureCodeId
        });
      });




      var NewJob = Object.assign({}, state.NewJobDetails)

      NewJob.CustomerId = Customer.Id
      NewJob.ContactPersonId = Contact.Id
      NewJob.CustomerDeliveryAddress = Address
      NewJob.Machines = subjobs

      //console.log('new job dto', Object.assign({}, NewJob))
      var result = await clientAPI.methods.createJob(NewJob)
        .finally(() => { state.CreateJobLoading = false });

      return result;
    },
  },



  getters: {
    JobDetails: state => {


      return state.OldJobDetails;
    },

    Order: state => {
      return state.Order;
    },

    SaveableJob: (state, getters, rootState, rootGetters) => {
      var Customer = rootGetters['JobHub/JobCustomer/Customer'];
      var Contact = rootGetters['JobHub/JobCustomer/CustomerContact'];
      var Address = rootGetters['JobHub/JobCustomer/CustomerDeliveryAdress'];

      var Subjobs = rootGetters['JobHub/JobSubjobs/Subjobs'];

      var saveable = true;







      if (
        !Customer
        || !Customer.Id
        || !Address
        || !Contact
        || !Contact.Id
      ) {
        console.warn('customer error')
        saveable = false;
      }



      if (
        !state.NewJobDetails
        || !state.NewJobDetails.JobStatusId
        || !state.NewJobDetails.JobTypeId
        || !state.NewJobDetails.JobPriorityId
        || !state.NewJobDetails.EstimatedTime
      ) {
        console.warn('jobdetails error')
        saveable = false;
      }



      if (!Subjobs || !Subjobs[0]) {
        console.warn('no machines')
        saveable = false;
      }
      Subjobs?.forEach((mac, index) => {
        if (!mac.CustomerComment || mac.CustomerComment.length < 1) {
          console.warn('invalid customer comment on machine ', index)
          saveable = false;
        }
      });

      return saveable;
    },

    JobStatus: state => {
      return state.OldJobDetails && state.OldJobDetails.JobStatusId
    },

    IsCompleteable: state => {
      if (state.OldJobDetails && state.OldJobDetails.JobStatusId < 50) {
        return true;
      }
      else {
        return false;
      }
    },

    IsApproveable: state => {
      if (state.OldJobDetails && state.OldJobDetails.JobStatusId > 49 && state.OldJobDetails.JobStatusId < 70) {
        return true;
      }
      else {
        return false;
      }
    },

    IsDeleteable: state => {
      if (state.OldJobDetails && state.OldJobDetails.JobStatusId != 110) {
        return true;
      }
      else {
        return false;
      }
    },

    LoadingCreate: state => {
      return state.CreateJobLoading;
    },
  },

};
